var render = function render(){var _vm=this,_c=_vm._self._c;return _c({template: '<span class=\'text-muted\'>' + _vm.content + '</span>'},{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }